var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('button',{staticClass:"btn btn-sm btn-outline-primary mx-1",attrs:{"type":"button","title":_vm.$t('notaComercial.pdf.openTitle')},on:{"click":_vm.openPdf}},[_c('i',{staticClass:"fas fa-file-pdf me-1",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.$t("notaComercial.pdf.openButton"))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }